import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ShoppingBag, Zap } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useSite } from "@/context/SiteContext";
import { btn } from "@/lib/ui";
import { QtySelector } from "./ProductBits";
import { CallButton, WhatsAppButton } from "@/components/common/ContactButtons";

export const ProductActions = ({ product, testid = "product" }) => {
  const [qty, setQty] = useState(1);
  const { add, setOpen } = useCart();
  const navigate = useNavigate();
  const { settings } = useSite();
  const out = !product.in_stock;

  if (!settings.online_payments_enabled) {
    return (
      <div className="space-y-3" data-testid={`${testid}-order-whatsapp`}>
        <WhatsAppButton size="lg" label="Order on WhatsApp" message={`Hello, I would like to order ${product.name}.`} className="w-full sm:w-auto" testid={`${testid}-order-whatsapp-btn`} />
        <p className="text-sm text-slate-600" data-testid={`${testid}-order-whatsapp-note`}>Send us a message on WhatsApp to place your order.</p>
      </div>
    );
  }

  const onAdd = () => {
    const r = add(product, qty);
    if (!r.ok) return toast.error(r.message);
    if (r.capped) toast.message(`Only ${product.stock} available. Your cart now has ${r.qty}.`);
    setOpen(true);
    return null;
  };
  const onBuy = () => navigate(`/checkout?buy=${product.id}&qty=${Math.min(qty, product.stock)}`);

  return (
    <div className="space-y-4">
      {!out && (
        <div className="flex items-center gap-4">
          <span className="text-sm font-semibold text-brand-ink" id={`${testid}-qty-label`}>Quantity</span>
          <QtySelector value={qty} onChange={setQty} max={Math.max(1, product.stock)} testid={`${testid}-qty`} />
        </div>
      )}
      <div className="grid gap-3 sm:grid-cols-2">
        <button type="button" disabled={out} onClick={onAdd} data-testid={`${testid}-add-to-cart-btn`} className={btn("outlineGreen", "lg")}>
          <ShoppingBag className="h-5 w-5" aria-hidden="true" /> Add to Cart
        </button>
        <button type="button" disabled={out} onClick={onBuy} data-testid={`${testid}-buy-now-btn`} className={btn("green", "lg")}>
          <Zap className="h-5 w-5" aria-hidden="true" /> Buy Now
        </button>
      </div>
      {out && (
        <div className="rounded-2xl bg-brand-tint p-4" data-testid={`${testid}-out-of-stock-note`}>
          <p className="text-base text-slate-700">This product is currently out of stock. Call or WhatsApp us to ask when it will be available again.</p>
          <div className="mt-3 flex flex-wrap gap-2">
            <CallButton label="Call us" size="sm" testid={`${testid}-oos-call-btn`} />
            <WhatsAppButton size="sm" message="Hello, I would like to know when Spine-Fit Tablets will be back in stock." testid={`${testid}-oos-whatsapp-btn`} />
          </div>
        </div>
      )}
    </div>
  );
};
